export function createShadow(depths, opacities) {
    if (depths.length !== 12 || opacities.length !== 3) {
        return 'none';
    }
    //Each line represents set of "offset-x | offset-y | blur-radius | spread-radius | color"
    return [
        depths[0] + "px " + depths[1] + "px " + depths[2] + "px " + depths[3] + "px rgba(0,0,0," + opacities[0] + ")",
        depths[4] + "px " + depths[5] + "px " + depths[6] + "px " + depths[7] + "px rgba(0,0,0," + opacities[1] + ")",
        depths[8] + "px " + depths[9] + "px " + depths[10] + "px " + depths[11] + "px rgba(0,0,0," + opacities[2] + ")",
    ].join(',');
}
